/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_UpdatesInputs */



/**
* | output |
* | --- |
* | "Monthly Software Updates" |
*
* @param {Signup_Compare_UpdatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_updates = /** @type {((inputs?: Signup_Compare_UpdatesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_UpdatesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "de") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "it") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "es") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Monthly Software Updates")
	return /** @type {LocalizedString} */ ("Monthly Software Updates")
});